import React, { Component } from "react";
import ClientCountries from "../../../shared/countries/ClientCountries";
import Search from "../../../shared/custom-components/search";
import { cleanIputTextNumber } from "../../../utils/functions";
import SecondaryButton from 'canvas-core-react/lib/SecondaryButton';
import personProvider from "../../../../../static/images/personProvider.svg";
import searchClient from "../../../../../static/images/find-institution.svg";
import i18next from 'i18next';
export class SearchProvider extends Component {
  constructor(props) {
    super(props);
    this.state = { searchValue: "", country: "", errors: [] };
  }

  cleanSearch = (e) => {
    e.preventDefault();
    this.setState({ searchValue: "" });
  };

  handlerChange = (event) => {
    if (event.key == "Enter") {
      this.searchAction();
    }
    this.setState({
      searchValue: cleanIputTextNumber(event.target.type, event.target.value),
    });
  };

  searchAction = () => {
    const { searchValue, country } = this.state;
    if (searchValue != "" && this.state.country !== "") {
      this.props.getProviderByCif(searchValue, country);
    } else {
      const { errors } = this.state;
      if (country == "") {
        errors["country"] = "Debe seleccionar un país";
      }
      this.setState({ errors });
    }
    return false;
  };

  setCountry = (e) => {
    this.setState({ country: e.target.value, errors: [] });
  };

  render() {
    return (
      <div className="manualMain">
        <div className="actions-title">
          <img src={personProvider} className="icon" />
          <p>{i18next.t('providers.search.title')}</p>
        </div>
        <div className="box-shadow">
          <div className="search2">
            <img src={searchClient} className="icon-client" />
            <h1 className="client-par">{i18next.t('providers.search.subtitle')}:</h1>
            <p className="ident">
            {i18next.t('providers.search.action')}
            </p>
            <div className="line red large"></div>
            <div className="inline-form">
              <ClientCountries
                id={`client-country`}
                className="client-country"
                onChange={(e) => this.setCountry(e)}
                error={this.state.errors["country"]}
              />
              <Search
                className="Input__input Search__input modifiy-search"
                id="search-field"
                name="searchValue"
                placeholder={i18next.t('general.placeholders.search')}
                onChange={this.handlerChange}
                onSearchClick={this.searchAction}
                onKeyDown={this.handlerChange}
                value={this.state.searchValue}
              />
            </div>
          </div>
        </div>
        <div className="form-actions clearfix">
          <SecondaryButton id="btn-upload-file" className="btnAgregar" onClick={() => this.searchAction()}>{i18next.t('general.buttons.add')}</SecondaryButton>
          <SecondaryButton className="btnLimpiar" onClick={(e) => this.cleanSearch(e)}>{i18next.t('general.buttons.clear')}</SecondaryButton>
        </div>
      </div>
    );
  }
}

export default SearchProvider;
